<template>
    <v-container>
        <Header
            :registryStatus="getNewsletterStatuses"
            :recordIndex="getNewsletterDetails.index"
            :registryTitle="getNewsletterRegistry.name"
            :registryUrl="'newsletter'"
            :actualStatus="getNewsletterDetails.status"
            :avatarData="getNewsletterDetails.createdBy"
            @status-changed="changeStatus"
        ></Header>
        <Main :items="items" class="p-relative">
            <v-tab-item
                v-for="item in items"
                :key="item.id"
                slot="tabItems"
                :id="item.id"
            >
                <component :is="item.component"></component>
            </v-tab-item>
            <div slot="information">
                <Information />
                <Modal
                    :title="$t('newsletter:edition')"
                    :open="open"
                    :height="'545'"
                    v-on:close="closeModal()"
                >
                    <AEContent slot="AEContent" />
                    <Buttons
                        @closeModal="open = false"
                        :action="'edit'"
                        slot="buttons"
                    />
                </Modal>
                <div class="d-flex justify-end buttons--details">
                    <v-tooltip left>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                fab
                                dark
                                v-on="on"
                                v-if="edit()"
                                small
                                @click="editNewsletter()"
                                class="buttons--add margin--1"
                            >
                                <v-icon small>mdi-pencil</v-icon>
                            </v-btn>
                        </template>
                        <span>{{ $t('newsletter:editNewsletter') }}</span>
                    </v-tooltip>
                </div>
            </div>
        </Main>
    </v-container>
</template>

<script>
import store from './../../../store/index'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import Information from '../../../components/Registries/Newsletter/Details/Information.vue'
import AEContent from './../../../components/Registries/Newsletter/Modal/Content'
import Buttons from './../../../components/Registries/Newsletter/Modal/Buttons'

export default {
    i18nOptions: { namespaces: ['global'] },
    components: {
        Information,
        AEContent,
        Buttons,
    },
    data() {
        return {
            open: false,
            items: [],
        }
    },
    computed: {
        ...mapGetters([
            'getNewsletterStatuses',
            'getNewsletterRegistry',
            'getNewsletterDetails',
        ]),
    },
    methods: {
        ...mapMutations([
            'setNewsletterDetails',
            'setNewsletterStatuses',
            'setNewsletterRegistry',
            'setNewsletterModal',
            'clearNewsletterErrors',
            'clearRepresentativesInput',
            'clearNewsletterModal'
        ]),
        ...mapActions(['fetchNewsletter', 'updateNewsletterStatus']),
        changeStatus(status) {
            this.updateNewsletterStatus({ status, id: this.getNewsletterDetails._id })
        },
        edit() {
            return this.checkPermissions('UPDATE')
        },
        async editNewsletter() {
            this.open = true
            this.clearNewsletterErrors()
            this.setNewsletterModal()
        },
        closeModal() {
            this.open = false
            this.clearNewsletterErrors()
            this.clearRepresentativesInput()
            this.clearNewsletterModal()
        },
    },
    beforeRouteEnter(to, from, next) {
        store.dispatch('fetchNewsletter', { id: to.params.id, next })
    },
}
</script>
